import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgxSpinnerService } from 'ngx-bootstrap-spinner';

@Component({
  selector: 'app-tutor-home',
  templateUrl: './tutor-home.component.html',
  styleUrls: ['./tutor-home.component.css']
})
export class TutorHomeComponent implements AfterViewInit {
  @ViewChild('landingVideo') landingVideo: ElementRef;

  constructor(private spinner: NgxSpinnerService) {}

  ngAfterViewInit(): void {
    this.spinner.show();
    this.landingVideo.nativeElement.addEventListener(
      'loadedmetadata',
      () => {
        this.spinner.hide();
      },
      false
    );
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView({behavior: 'smooth'});
  }
}
